import React, { Component } from 'react';
import './RadioButton.css';

/* Radio Button Styles based on guide at https://www.templatemonster.com/blog/style-checkboxes-radio-buttons-css/*/
export default class RadioButton extends Component {
  render() {
    return (
      <div className="RadioButton_Div" onClick={this.props.onChange}>
        <input
          type="radio"
          name="action"
          id={this.props.uniqueID}
          checked={this.props.isChecked}
          onChange={() => {
            /* This is a controlled component, but the parent handles state and passes it as a prop, and onclick is handled on 
                               surrounding div. However, this function needs to exist to suppress a warning.  */
          }}
        />
        <label htmlFor={this.props.uniqueID}>
          <span className="RadioButton_Span">{this.props.text}</span>
        </label>
      </div>
    );
  }
}
